var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01754 11.8348L17.1101 0.650444C17.4237 0.302907 17.836 0.116032 18.3469 0.0898164C18.8578 0.0636011 19.287 0.207299 19.6345 0.52091C19.982 0.834522 20.1689 1.24677 20.1951 1.75766C20.2214 2.26855 20.0777 2.69776 19.764 3.0453L8.47403 15.5566C8.13191 15.9358 7.72043 16.1377 7.23959 16.1623C6.75876 16.187 6.32878 16.0283 5.94964 15.6862L1.02094 11.2386C0.673398 10.925 0.486523 10.5127 0.460308 10.0018C0.434093 9.49095 0.57779 9.06174 0.891402 8.7142C1.20501 8.36666 1.61726 8.17979 2.12815 8.15357C2.63904 8.12736 3.06825 8.27105 3.41579 8.58466L7.01754 11.8348Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackTick);
export default __webpack_public_path__ + "static/media/blackTick.2071f635b0ba7de778bf5651f59ff6e1.svg";
export { ForwardRef as ReactComponent };